import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./expected-value-config-form.i18n";

type ExpectedValueConfigFormProps = {
  flowLanguage: string;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  showSummaryTable: boolean;
  onShowSummaryTableChange: (show: boolean) => void;
  showYearlyTable: boolean;
  onShowYearlyTableChange: (show: boolean) => void;
};

export function ExpectedValueConfigForm({
  flowLanguage,
  showChart,
  onShowChartChange,
  showSummaryTable,
  onShowSummaryTableChange,
  showYearlyTable,
  onShowYearlyTableChange,
}: ExpectedValueConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div className="space-y-2">
        <Label className="text-base">{t.displayOptions}</Label>
        <p className="text-sm text-muted-foreground">{t.displayDesc}</p>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-chart" className="text-base">
            {t.showChart}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showLineChart}</p>
        </div>
        <Switch
          id="expected-value-show-chart"
          checked={showChart}
          onCheckedChange={onShowChartChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-summary-table" className="text-base">
            {t.showSummaryTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.summaryTableDesc}</p>
        </div>
        <Switch
          id="expected-value-show-summary-table"
          checked={showSummaryTable}
          onCheckedChange={onShowSummaryTableChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="expected-value-show-yearly-table" className="text-base">
            {t.showYearlyTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.yearlyTableDesc}</p>
        </div>
        <Switch
          id="expected-value-show-yearly-table"
          checked={showYearlyTable}
          onCheckedChange={onShowYearlyTableChange}
        />
      </div>

      {!showChart && !showSummaryTable && !showYearlyTable && (
        <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md">
          {t.atLeastOneOption}
        </div>
      )}
    </div>
  );
}
